export const DAILY_BOOST_CATEGORY_SLUG = 'daily-boost';
export enum ShortCardVariants {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
